import apiClient, { setAuthToken } from './api.client';

function ensureAuth() {
  const token = localStorage.getItem('token');
  if (token) setAuthToken(token);
}

function makeAbsoluteUrl(url) {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = apiClient.defaults.baseURL || process.env.REACT_APP_BASE_URL || window.location.origin;
  // ensure no double slash
  if (base.endsWith('/') && url.startsWith('/')) return base.slice(0, -1) + url;
  if (!base.endsWith('/') && !url.startsWith('/')) return base + '/' + url;
  return base + url;
}

async function uploadSingle(file) {
  ensureAuth();
  const form = new FormData();
  form.append('file', file);
  const res = await apiClient.post('/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const data = res.data;
  // backend may return { filename, path } or { id, url, itemId }
  const url = data.url || data.path || (data.filename ? `/uploads/${data.filename}` : undefined);
  return {
    ...data,
    url: makeAbsoluteUrl(url),
  };
}

async function uploadMultiple(files = []) {
  ensureAuth();
  const form = new FormData();
  files.forEach((f) => form.append('files', f));
  const res = await apiClient.post('/upload/multiple', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const arr = res.data || [];
  return arr.map((data) => {
    const url = data.url || data.path || (data.filename ? `/uploads/${data.filename}` : undefined);
    return { ...data, url: makeAbsoluteUrl(url) };
  });
}

export default {
  uploadSingle,
  uploadMultiple,
};
